import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '../../resources/submission';
import {IConfigSchema,} from '../../resources/config-schema';
import {getIndicators} from './calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'II. PARTECIPAZIONE ALLE ATTIVITA’ COLLETTIVE',
    tooltip: 'Il visual mostra il grado di partecipazione dei beneficiari anziani alle attività collettive, confrontando la percentuale di beneficiari che hanno partecipato agli eventi sui beneficiari invitati, secondo le compilazioni della “Scheda rilevazione attività collettive”, e il valore che si prevede di raggiungere per la stessa variabile (50% di partecipazione) a conclusione del progetto',
    type: 'column',
    categories: ['Percentuale di beneficiari che hanno partecipato alle attività collettive su beneficiari invitati'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: [getIndicators(submissions)]
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [50]
        },
    ],
});